import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useSite } from '@salesforce/storefront-next-runtime/site-context';
import { formatCurrency } from '@/lib/currency';
import { cn } from '@/lib/utils';
import type { OrderSummaryBasket } from './mobile-heading-utils';

interface B2BEstTotalProps {
    basket: OrderSummaryBasket;
    className?: string;
}

/**
 * B2B summary line: the basket/order total only, labelled Est. Total.
 * Replaces the subtotal/shipping/tax breakdown wherever B2B is enabled.
 */
export function B2BEstTotal({ basket, className }: B2BEstTotalProps): ReactElement {
    const { t, i18n } = useTranslation('cart');
    const { currency: siteCurrency } = useSite();
    const total = basket.orderTotal ?? basket.productTotal ?? 0;

    return (
        <div
            className={cn(
                'flex w-full items-center justify-between text-sm font-bold leading-5 text-muted-foreground',
                className
            )}
            data-testid="b2b-est-total">
            <span>{t('summary.estTotalB2B', { defaultValue: 'Est. Total' })}</span>
            <span>{formatCurrency(total, i18n.language, basket.currency ?? siteCurrency)}</span>
        </div>
    );
}
